import React from 'react';

import { SuiButton } from '@splashthat/sui';

import LockIcon from 'common/icons/LockFill';

const LOCK_TITLE = 'Locked';

export default function FixedControlLock(props) {
    return <SuiButton variation="navigation" size="small" icon={LockIcon} title={LOCK_TITLE} aria-label={LOCK_TITLE} />;
}
